import styled from 'styled-components';
import { colors } from '../colors';

const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	border-spacing: 0px;
	border: 1px solid ${colors.Border2};
	border-radius: 6px;

	thead {
		tr {
			th {
				text-align: left;
				font-weight: normal;
				border-bottom: 1px solid ${colors.Border2};
				font-size: 14px;
				line-height: 18px;
				color: ${colors.Grey};
				padding: 14px 1px 14px 33px;
				white-space: nowrap;

				:last-child {
					text-align: center !important;
				}
			}
		}
	}
	tbody {
		tr {
			td {
				font-size: 14px;
				line-height: 18px;
				color: ${colors.Grey};
				padding: 14px 1px 14px 33px;
				max-width: 150px;
				white-space: normal; /* Allow text to wrap */
				word-wrap: break-word; /* Break words if necessary */

				:last-child {
					text-align: left;
				}
			}
		}
	}
`;

export default Table;
